import { Prism as SyntaxHighlighter } from "react-syntax-highlighter"
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism"

type CodeBlockProps = {
  code: string
  language?: string
}

export function CodeBlock({ code, language = "typescript" }: CodeBlockProps) {
  return (
    <SyntaxHighlighter
      language={language}
      style={oneLight}
      showLineNumbers
      customStyle={{ borderRadius: "0.5rem", fontSize: "0.75rem", margin: 0 }}
    >
      {code}
    </SyntaxHighlighter>
  )
}
